module.exports = __webpack_public_path__ + "assets/img/title3-77de64aa.png";